import React from 'react'
import { Box, Button, Typography, Alert } from '@mui/material'
import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import useExcelParse from '../useExcelParse'

const StepUploadFile = ({ onFileUpload, _currentStep, setCurrentStep, _errors, _status }) => {
    const { handleChange, excelData, errors: parseErrors, status: parseStatus, excelFile } = useExcelParse()

    const handleFileUpload = (event) => {
        const file = event.target.files[0]
        if (file) {
            handleChange(file)
        }
    }

    // Quand le parsing est terminé, passer au step suivant
    React.useEffect(() => {
        if (parseStatus === 'finished' && excelData.length > 0) {
            onFileUpload(excelData, parseErrors, parseStatus)
            setCurrentStep(2)
        }
    }, [parseStatus, excelData, parseErrors, onFileUpload, setCurrentStep])

    return (
        <Box>
            <Box
                sx={{
                    border: '2px dashed #ccc',
                    borderRadius: 2,
                    p: 4,
                    textAlign: 'center',
                    backgroundColor: '#f5f5f5',
                    mb: 2,
                }}>
                <CloudUploadIcon sx={{ fontSize: 60, color: '#1976d2', mb: 2 }} />
                <Typography variant='body1' gutterBottom>
                    Upload an Excel file containing product prices
                </Typography>
                <Typography variant='body2' color='textSecondary' gutterBottom>
                    Supported formats: .xlsx, .xls
                </Typography>
                <Button component='label' variant='contained' startIcon={<CloudUploadIcon />} sx={{ mt: 2 }}>
                    {excelFile && excelFile.length > 0 ? 'Change File' : 'Choose File'}
                    <input type='file' hidden accept='.xlsx,.xls' onChange={handleFileUpload} />
                </Button>
            </Box>

            {excelFile && excelFile.length > 0 && parseStatus === 'finished' && (
                <Alert severity='success' icon={<CheckCircleIcon />} sx={{ mt: 2 }}>
                    <Typography variant='body1'>
                        <strong>File selected:</strong> {excelFile[0].name}
                    </Typography>
                    <Typography variant='body2' color='text.secondary'>
                        {excelData.length} rows loaded successfully
                    </Typography>
                </Alert>
            )}

            {parseStatus === 'error' && parseErrors.length > 0 && (
                <Alert severity='error' sx={{ mt: 2 }}>
                    <Typography variant='body2' fontWeight='bold'>
                        Errors found:
                    </Typography>
                    {parseErrors.map((error, index) => (
                        <Typography key={index} variant='body2'>
                            • {error}
                        </Typography>
                    ))}
                </Alert>
            )}

            {parseStatus === 'loading' && (
                <Typography variant='body2' color='textSecondary' sx={{ mt: 2, textAlign: 'center' }}>
                    Loading file...
                </Typography>
            )}
        </Box>
    )
}

export default StepUploadFile
